// extracted by mini-css-extract-plugin
export default {"recos":"B4-z","productCardOverride":"C4-z","rowHasBadge":"D4-z"};